import React from 'react'
import { NavLink } from 'react-router-dom'

export default function PageHeader({
    title,
    href,
    download,
    button_label,
    button_label1,
    button_label2,
    link_to,
    link_to1,
    className,
    className1,
    buttonAttributes = {},
    buttonAttributes1 = {},
    buttonAttributes2 = {},
    className2,
    extraButtons,

}) {
    return (
        <>
            <div className="header">
                <div className="header-body">
                    <div className="row align-items-end">
                        <div className="col">
                            <h2 className="header-title">
                                {title}
                            </h2>
                        </div>
                        <div className="col-auto">
                        {extraButtons}
                            {
                                button_label !== undefined && button_label !== '' ?
                                    (
                                        href ?
                                            (
                                                <a href={href} className={className} download={download}>
                                                    {button_label}
                                                </a>
                                            )
                                            :
                                            (
                                                <NavLink to={link_to} className={className} {...buttonAttributes}>
                                                    {button_label}
                                                </NavLink>
                                            )
                                    )
                                    : ""
                            }

                            {
                                button_label1 !== undefined && button_label1 !== '' ?
                                    (
                                        <NavLink to={link_to1} className={className1}  {...buttonAttributes1}>
                                            {button_label1}
                                        </NavLink>
                                    )
                                    : ""
                            }
                            {
                                button_label2 !== undefined && button_label2 !== '' ?
                                    (
                                        <NavLink to={link_to1} className={className2}  {...buttonAttributes2}>
                                            {button_label2}
                                        </NavLink>
                                    )
                                    : ""
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
